module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate13.10af265.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate13.png
// module id = 748
// module chunks = 0